const BLOG_SITE_URL = "https://www.harivishnu.in";

export function normalizeBlogSegment(value: unknown): string {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return normalized || "uncategorized";
}

interface BlogCategory {
  slug?: string;
  name?: string;
}

interface BlogPost {
  slug?: string;
  category?: BlogCategory | BlogCategory[] | string | null;
  categories?: BlogCategory[] | string | null;
}

export function resolveBlogCategorySlug(post: BlogPost | null | undefined): string {
  const category = post?.category || post?.categories || null;

  if (Array.isArray(category) && category.length > 0) {
    const primaryCategory = category[0];
    if (primaryCategory && typeof primaryCategory === 'object' && 'slug' in primaryCategory && primaryCategory.slug) {
      return normalizeBlogSegment(primaryCategory.slug);
    }
    if (primaryCategory && typeof primaryCategory === 'object' && 'name' in primaryCategory && primaryCategory.name) {
      return normalizeBlogSegment(primaryCategory.name);
    }
  }

  if (category && typeof category === 'object' && 'slug' in category && category.slug) {
    return normalizeBlogSegment(category.slug);
  }

  if (category && typeof category === 'object' && 'name' in category && category.name) {
    return normalizeBlogSegment(category.name);
  }

  if (typeof category === "string" && category.length !== 24) {
    return normalizeBlogSegment(category);
  }

  return "uncategorized";
}

export function getBlogPostPath(post: BlogPost | null | undefined): string {
  const slug = String(post?.slug || "").trim();
  if (!slug) {
    return "/blog";
  }

  return `/blog/${resolveBlogCategorySlug(post)}/${slug}`;
}

export function getBlogPostUrl(post: BlogPost | null | undefined): string {
  return `${BLOG_SITE_URL}${getBlogPostPath(post)}`;
}

export function getBlogPostPathFromParts(slug: string | null | undefined, categorySlug: string | null | undefined): string {
  const normalizedSlug = String(slug || "").trim();
  if (!normalizedSlug) {
    return "/blog";
  }

  return `/blog/${normalizeBlogSegment(categorySlug)}/${normalizedSlug}`;
}

export function getBlogPostUrlFromParts(slug: string | null | undefined, categorySlug: string | null | undefined): string {
  return `${BLOG_SITE_URL}${getBlogPostPathFromParts(slug, categorySlug)}`;
}
